module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfooter"
  }, [_c('ul', [_c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/post'
      }
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("发表")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/message'
      }
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("消息")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/me'
      }
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("我的")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93473d20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footer.vue
// module id = 145
// module chunks = 1